import { createSelector } from 'reselect';
import { STUFF } from './types';

const getStuff = (state: { app: { template: STUFF } }): string => state.app.template.stuff;

export const getStuffSelector = createSelector(
    [getStuff],
    (stuff) => stuff,
);
